import React, {useState} from "react";
import axios from "axios";
import {Autocomplete, Button, Grid, Paper, TextField} from "@mui/material";
import Typography from "@mui/material/Typography";
import SaveIcon from "@mui/icons-material/Save";
import Container from "@mui/material/Container";
import {useSession} from "./contexts/SessionContext";

const TIMEZONES: string[] = (Intl as any).supportedValuesOf('timeZone')

export default function UserSettings() {
    const {user} = useSession();
    const [displayName, setDisplayName] = useState(user?.display_name ?? '');
    const [timezone, setTimezone] = useState(user?.timezone ?? 'America/New_York');
    const [saved, setSaved] = useState(false);
    const [nameError, setNameError] = useState<string | null>(null);

    async function saveSettings() {
        try {
            setNameError(null);
            await axios.put('/auth/me', {display_name: displayName, timezone});
            setSaved(true);
            setTimeout(() => setSaved(false), 2000);
        } catch (err: any) {
            if (err?.response?.status === 409) {
                setNameError(err.response.data?.error ?? 'This display name is already in use.')
            }
        }
    }

    return <React.Fragment>
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <Paper elevation={2} sx={{p: 1}}>
                    <Typography variant="h4" align="center">User Settings</Typography>
                </Paper>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Paper elevation={2} sx={{p: 2}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField fullWidth label="Email" disabled
                                       value={user?.email ?? ''}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField fullWidth label="Display Name"
                                       value={displayName}
                                       error={!!nameError}
                                       helperText={nameError ?? ''}
                                       onChange={(ev) => { setDisplayName(ev.target.value); setNameError(null); }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                options={TIMEZONES}
                                value={timezone}
                                onChange={(_, val) => setTimezone(val ?? 'UTC')}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="Timezone"/>
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Container sx={{textAlign: 'center'}}>
                                <Button variant="contained" startIcon={<SaveIcon/>} onClick={saveSettings}>
                                    {saved ? 'Saved!' : 'Save'}
                                </Button>
                            </Container>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    </React.Fragment>
}